import styled, { css } from "styled-components";

interface IProps {
  mine: boolean;
}

const StandingsRow = styled.tr<IProps>`
  ${(props) =>
    props.mine &&
    css`
      td {
        background-color: ${({ theme }) => theme.colors.primary};
        color: white;
        > a {
          color: ${({ theme }) => theme.colors.yellowLight};
        }
      }
    `}
`;
export default StandingsRow;
